import { CropChip } from '@cibo/ui'
import { DetailSimpleCellProps } from '../types'

export const CashCropDetailSimpleCell = ({ detail }: DetailSimpleCellProps) => (
  <CropChip
    crop={detail?.result}
    preventPlant={detail?.input?.preventPlant}
    source={detail?.source}
  />
)
